module.exports = __webpack_public_path__ + "static/media/LondonPhone.1cb0f088.svg";